/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import find from 'lodash/find';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import LoadingBar from '../share/LoadingBar';
import BasicToolBar from '../share/BasicToolBar';
import DeleteConfirmDialog from '../share/DeleteConfirmDialog';
import GeneralDialog from '../share/GeneralDialog';
import {
  commonResourceStyle,
  displayResourceStyles,
  generalDialogStyles,
  deleteConfirmationDialogStyles,
} from '../../css/style';
import { searchEntity } from '../../utils/Functions';
import CategoryCard from './CategoryCard';
import { bulkActions } from '../../data/Constants';

const styles = commonResourceStyle();
const displayStyles = displayResourceStyles();
const bulkActionStyles = generalDialogStyles();
const actionConfirmStyles = deleteConfirmationDialogStyles();

class Categories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDeleteConfirmDialogOpen: false,
      dataInDeleteConfirmDialog: null,
      isBulkActionConfirmDialogOpen: false,
      selectedBulkAction: '',
      searchedTerm: null,
      searchedCategory: [],
    };
  }

  componentDidMount() {
    this.getCategoryResources();
  }

  componentDidUpdate(prevProps) {
    const { apiToken } = this.props;
    if (prevProps.apiToken !== apiToken) {
      this.getCategoryResources(true);
    }
  }

  getCategoryResources = async (forceFetch = false) => {
    const {
      actions, apiToken, categories,
    } = this.props;
    if (!categories || forceFetch || get(this.props, 'location.state.fromCreateAndEditResource')) {
      await actions.getAllResources(apiToken, 'categories');
    }
  }

  onClickEdit = (data) => {
    const {
      actions, match, history,
    } = this.props;
    const { resource, resourceId } = match.params;
    actions.clearErrors();
    const resourceName = 'categories';
    if (resourceId) {
      history.push(`/${resource}/${resourceId}/${resourceName}/${data.id}/edit`);
    } else {
      history.push(`/${resourceName}/${data.id}/edit`);
    }
  }

  onClickDelete = async (data) => {
    this.setState({
      isDeleteConfirmDialogOpen: true,
      dataInDeleteConfirmDialog: data,
    });
  }

  getTargetResourceNames = (action) => {
    const { isDeleteConfirmDialogOpen, dataInDeleteConfirmDialog } = this.state;
    if (action === 'delete' && isDeleteConfirmDialogOpen) return dataInDeleteConfirmDialog.name;
    return '';
  }

  onCloseDialog = () => {
    this.setState({ isDeleteConfirmDialogOpen: false, isBulkActionConfirmDialogOpen: false });
  }

  onClickConfirmDeleteButton = async () => {
    const {
      actions, apiToken, onClickDeleteResource,
    } = this.props;
    const { dataInDeleteConfirmDialog } = this.state;
    const resource = 'categories';
    actions.clearErrors();

    if (typeof onClickDeleteResource === 'function') {
      onClickDeleteResource(dataInDeleteConfirmDialog.id);
      this.onCloseDialog();
      return;
    }
    actions.deleteResource(apiToken, resource, dataInDeleteConfirmDialog.id);
    this.onCloseDialog();
  }

  onClickAddResourceOverride = () => {
    const {
      actions, history,
    } = this.props;
    actions.clearErrors();
    history.push('categories/create');
  }

  onBulkActionDropdownChange = (event) => {
    const { selectedItems } = this.props;
    const { value } = event.target;
    if (Object.keys(bulkActions).includes(value)
      && find(selectedItems, isChecked => !!isChecked)) {
      this.setState({
        isBulkActionConfirmDialogOpen: true,
        selectedBulkAction: value,
      });
    }
  }

  bulkActionMessage = () => {
    const { selectedBulkAction } = this.state;
    const { selectedItems } = this.props;
    const targetResources = selectedItems;
    const targetResourceNames = Array.isArray(targetResources)
      ? targetResources.map(resource => (
        <div key={resource.id} style={bulkActionStyles.truncatedBulkTargetResourceName}>
          {resource.name}
        </div>
      ))
      : [];
    const targetResourcesContainerStyle = targetResourceNames.length < 6
      ? actionConfirmStyles.bulkTargetResources
      : actionConfirmStyles.bulkTargetResourcesWithVertScrollbar;
    return (
      <div style={bulkActionStyles.messageAndTargetResourcesContainer}>
        <Typography style={bulkActionStyles.bulkActionAreYouSureQuestion}>
          {bulkActions[selectedBulkAction].dialogConfirmText.replace(/#RESOURCE#/g, 'categories')}
        </Typography>
        <div style={targetResourcesContainerStyle}>
          {targetResourceNames}
        </div>
      </div>
    );
  }

  bulkActionConfirmCancelButtons = () => {
    const { selectedBulkAction } = this.state;
    return (
      <div>
        <Button
          style={actionConfirmStyles.confirmButton}
          onClick={this.onClickConfirmBulkAction}
        >
          {bulkActions[selectedBulkAction].dialogBtnText.replace(/#RESOURCE#/g, 'categories').toUpperCase()}
        </Button>
        <Typography
          style={actionConfirmStyles.cancelText}
          onClick={this.onCloseDialog}
        >
          Cancel
        </Typography>
      </div>
    );
  }

  onClickConfirmBulkAction = () => {
    const { selectedBulkAction } = this.state;
    const {
      actions,
      apiToken,
      selectedItems,
    } = this.props;
    if (selectedBulkAction === '') {
      this.setState({ isBulkActionConfirmDialogOpen: false });
      return;
    }
    this.setState({ isBulkActionConfirmDialogOpen: false });
    if (Object.keys(bulkActions).includes(selectedBulkAction)) {
      const payload = selectedItems
        .map((p) => {
          const basePayload = { id: p.id };
          return basePayload;
        });
      actions.unselectAllItems();
      actions.updateResource(apiToken, payload, 'categories', bulkActions[selectedBulkAction].uri);
    }
  }

  handleSearch = (term) => {
    const { categories } = this.props;
    const searchEntityResult = searchEntity(term, categories, 'name');
    this.setState({
      searchedTerm: term,
      searchedCategory: searchEntityResult,
    });
  }

  handleClearSearch = () => {
    this.setState({
      searchedTerm: null,
    });
  }

  getCategoriesArray = () => {
    const { categories } = this.props;
    const { searchedTerm } = this.state;
    const { searchedCategory } = this.state;
    let category;
    if (searchedTerm) {
      category = searchedCategory;
    } else {
      category = categories;
    }
    return category;
  }

  isCheckedCategory = (category) => {
    const { selectedItems } = this.props;
    if (!selectedItems) {
      return false;
    }
    return selectedItems.includes(category);
  }

  isCheckedCategories = (categories) => {
    const { selectedItems } = this.props;
    if (!selectedItems) {
      return false;
    }
    return categories.every(category => selectedItems.includes(category));
  }

  onCheckCategories = (event) => {
    const { categories, actions } = this.props;
    if (event.target.checked) {
      actions.selectAllItems(categories);
    } else {
      actions.unselectAllItems();
    }
  }

  render() {
    const {
      categories, actions, loading, apiToken, match, selectedItems,
    } = this.props;
    const {
      isDeleteConfirmDialogOpen,
      isBulkActionConfirmDialogOpen,
      selectedBulkAction,
    } = this.state;
    const filteredCategories = this.getCategoriesArray();

    return (
      (loading === true)
        ? <LoadingBar />
        : (
          <div style={styles.container}>
            <div style={styles.resourceHeader}>
              <BasicToolBar
                actions={actions}
                resourceName="categories"
                handleSearch={this.handleSearch}
                handleClearSearch={this.handleClearSearch}
                onClickAddResourceOverride={this.onClickAddResourceOverride}
                isBulkActions
                onBulkActionDropdownChange={this.onBulkActionDropdownChange}
              />
            </div>
            <div style={styles.categoriesContainer}>
              <div style={styles.categoryContainer}>
                <div style={styles.categoryHeaderContainer}>
                  <Checkbox
                    style={styles.itemsHeaderCheckBox}
                    onChange={event => this.onCheckCategories(event)}
                    checked={this.isCheckedCategories(categories)}
                    icon={(
                      <Icon style={displayStyles.uncheckedCheckboxIcon}>
                        check_box_outline_blank
                      </Icon>
                    )}
                    checkedIcon={<Icon style={displayStyles.checkedCheckboxIcon}>check_box</Icon>}
                  />
                  <Typography style={styles.itemsHeaderText}>NAME</Typography>
                  <Typography style={styles.itemsHeaderText}>ENABLE CATEGORY</Typography>
                  <div style={styles.itemsHeaderThreeDot} />
                </div>
                <div style={styles.categoryHeaderBorderStyle} />
                { filteredCategories
                  && filteredCategories.map(category => (
                    <CategoryCard
                      category={category}
                      onClickEdit={() => this.onClickEdit(category)}
                      actions={actions}
                      apiToken={apiToken}
                      match={match}
                      onClickDelete={() => this.onClickDelete(category)}
                      selectedItems={selectedItems}
                      isChecked={() => this.isCheckedCategory(category)}
                    />
                  ))}
              </div>
            </div>
            <DeleteConfirmDialog
              resourceName='categories'
              isDialogOpen={isDeleteConfirmDialogOpen}
              deleteDataName={this.getTargetResourceNames('delete')}
              onCloseDialog={this.onCloseDialog}
              onClickConfirmButton={this.onClickConfirmDeleteButton}
            />
            {selectedBulkAction && (
              <GeneralDialog
                type="bulkAction"
                open={isBulkActionConfirmDialogOpen}
                onClose={this.onCloseDialog}
                contentContainerStyle={bulkActionStyles.bulkActionDialogContainer}
                title={bulkActions[selectedBulkAction].dialogTitle.replace(/#RESOURCE#/g, 'products').toUpperCase()}
                message={this.bulkActionMessage()}
                buttons={this.bulkActionConfirmCancelButtons()}
              />
            )}
          </div>
        )
    );
  }
}

Categories.propTypes = {
  loading: PropTypes.bool.isRequired,
  categories: PropTypes.arrayOf(PropTypes.object),
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  selectedItems: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  onClickDeleteResource: PropTypes.func.isRequired,
};

Categories.defaultProps = {
  categories: null,
};

export default withRouter(Categories);
